import React, { useState } from 'react';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

const PdfAddPageNumbers = () => {
  const [pdfFile, setPdfFile] = useState(null);

  const handleAddPageNumbers = async () => {
    if (!pdfFile) return;

    const arrayBuffer = await pdfFile.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const totalPages = pdfDoc.getPageCount();

    pdfDoc.getPages().forEach((page, index) => {
      const { width } = page.getSize();

      const fontSize = 12;
      const text = `Page ${index + 1} of ${totalPages}`;

      page.drawText(text, {
        x: width / 2 - (font.widthOfTextAtSize(text, fontSize) / 2),
        y: 20, // 20 points from bottom
        size: fontSize,
        font,
        color: rgb(0.5, 0.5, 0.5),
      });
    });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'pdf_with_page_numbers.pdf';
    a.click();
  };

  return (
    <div>
    <div>
      <h2>Add Page Numbers to PDF</h2>
      <input type="file" accept="application/pdf" onChange={(e) => setPdfFile(e.target.files[0])} />
      <br /><br />
      <button onClick={handleAddPageNumbers} disabled={!pdfFile}>
        Add Page Numbers & Download
      </button>
    </div>
    <div className="content">

  <h2>PDF Cropper: Trim Unwanted Edges and Focus on What Matters</h2>

  <p>
    PDFs often contain unnecessary margins, blank spaces, headers, footers, or 
    unwanted elements that distract from the main content. The PDF Cropper tool 
    helps you clean up your document by trimming edges and focusing only on the 
    essential parts of each page.
  </p>

  <p>
    Whether you're preparing documents for presentations, printing, studying, 
    or archiving, cropping ensures your PDF looks clean, sharp, and 
    professional.
  </p>

  <h3>Why Crop a PDF?</h3>

  <ul>
    <li>Remove unwanted margins or white spaces</li>
    <li>Eliminate page numbers, watermarks, or irrelevant content</li>
    <li>Make scanned PDFs cleaner and easier to read</li>
    <li>Improve document appearance for printing or display</li>
    <li>Focus attention on the core content of the page</li>
  </ul>

  <h3>How the PDF Cropping Process Works</h3>

  <h4>1. Upload Your PDF File</h4>
  <p>
    Start by selecting the PDF you want to crop. The tool loads each page and 
    displays a preview so you can choose the perfect crop area.
  </p>

  <h4>2. Select the Crop Area</h4>
  <p>
    Use the interactive cropping box to highlight the exact region you want to 
    keep. Adjust the width and height by dragging the corners or edges.
  </p>

  <h4>3. Apply the Crop</h4>
  <p>
    Once satisfied with the selection, apply the crop. The tool will trim each 
    selected page accordingly, removing everything outside the chosen area.
  </p>

  <h4>4. Crop Multiple Pages (Optional)</h4>
  <p>
    Apply the same crop dimensions across all pages, or crop each page individually 
    for the best results.
  </p>

  <h3>Your Final Cropped PDF</h3>
  <p>
    After processing, you’ll receive a clean, refined PDF free of distractions. 
    Your cropped document is ready for viewing, printing, sharing, or further editing.
  </p>

</div>

    </div>
  );
};

export default PdfAddPageNumbers;
// src/components/PdfpageToNumbers.js